import { Component, input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ChartTypeColorsEnum } from '../../../utils/enums/chart-colors.enum';
import { IAnswerDetail } from '../../../utils/interfaces/summary-report';
import {
  AllColors,
  EColorsWeight,
  SingleColor,
} from '../../../utils/type-colors';

@Component({
  selector: 'app-custom-bar-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-bar-chart.component.html',
  styleUrl: './custom-bar-chart.component.scss',
})
export class CustomBarChartComponent {
  data = input.required<IAnswerDetail[]>();

  dataType = input.required<ChartTypeColorsEnum>();
  chartColorsEnum = ChartTypeColorsEnum;

  singleColor = SingleColor;
  colorsWeight = EColorsWeight;
  allColors = AllColors;

  colorDescriptionWeight = ['', '#FFCD8F', '#FFE88F', '#D7E99C', '#9EE19E'];
}
